import React from "react";

export type ProfileDisclosureChevronProps = Readonly<{
  className?: string;
  expanded: boolean;
}>;

export function ProfileDisclosureChevron({
  className,
  expanded,
}: ProfileDisclosureChevronProps) {
  return (
    <svg
      aria-hidden="true"
      className={[
        "profile-disclosure-chevron",
        expanded ? "profile-disclosure-chevron--expanded" : "",
        className,
      ].filter(Boolean).join(" ")}
      focusable="false"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="m6 9 6 6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
